// Centralised client-side logger. Non-blocking, best-effort.
// Ships structured error events to POST /api/log/client so we can spot production
// failures without asking users to send screenshots of console.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const client = axios.create({ baseURL: API, timeout: 5000 });

// throttle: don't spam the endpoint with identical repeats within the same session
const seen = new Map();
const THROTTLE_MS = 60000;

function throttled(key) {
  const now = Date.now();
  const last = seen.get(key) || 0;
  if (now - last < THROTTLE_MS) return true;
  seen.set(key, now);
  return false;
}

export function logClientError(event, context = {}) {
  const key = event + "|" + (context.msg || "");
  if (throttled(key)) return;
  try {
    // Fire-and-forget — do NOT await, do NOT throw
    client
      .post("/log/client", {
        event,
        context,
        url: typeof window !== "undefined" ? window.location.href : "",
        ua: typeof navigator !== "undefined" ? navigator.userAgent : "",
        ts: new Date().toISOString(),
      })
      .catch(() => { /* swallow — never break UX to log an error */ });
  } catch { /* noop */ }
  if (typeof console !== "undefined") {
    // Always mirror to console so devs can still see it
    console.warn(`[djspy:${event}]`, context);
  }
}

// Global window handlers — install once
let installed = false;
export function installGlobalHandlers() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (e) => {
    logClientError("window.error", { msg: e?.message, src: e?.filename, line: e?.lineno });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e?.reason;
    logClientError("window.unhandled_rejection", {
      msg: (reason && (reason.message || String(reason))) || "unknown",
    });
  });
}
